import {AssertionUtils} from '../utils/assertion-utils';
import {TimeUtils} from '../utils/time-utils';

export function convertSpeedAndCycleTime(value: number): number {
  if (!AssertionUtils.isNullOrUndefined(value) && value !== 0) {
    return TimeUtils.SECONDS_IN_A_MINUTE / value;
  }

  return value;
}
